const isMissingDemoTableError = (error) => {
  const message = String(error?.message || "");
  return error?.code === "42P01" || message.includes("demo_user_institutes") || message.includes("demo_profiles");
};

export const mapDemoInstituteMemberRow = (row = {}) => {
  const profile = row.demo_profiles || row.profiles || {};
  return {
    id: row.id,
    institute_id: row.institute_id,
    profile_id: row.demo_profile_id,
    demo_profile_id: row.demo_profile_id,
    is_demo_profile: true,
    steps: row.steps ?? 0,
    lifetime_steps: row.lifetime_steps ?? 0,
    team_id: row.team_id || null,
    association_type: row.association_type,
    status: row.status,
    profiles: {
      id: row.demo_profile_id,
      name: profile.name || "",
      surname: profile.surname || "",
      username: profile.username || "",
      profile_img: profile.profile_img || "",
      level: profile.level ?? 1,
    },
  };
};

export const fetchDemoInstituteMemberRows = async (supabase, {
  instituteId,
  instituteIds,
  teamId,
  activeOnly = false,
  includeFormer = false,
} = {}) => {
  const ids = instituteIds || (instituteId ? [instituteId] : []);
  if (!ids.length && !teamId) return [];
  let query = supabase
    .from("demo_user_institutes")
    .select("id,demo_profile_id,institute_id,steps,lifetime_steps,team_id,association_type,status,demo_profiles(id,name,surname,username,profile_img,level)");
  if (ids.length === 1) query = query.eq("institute_id", ids[0]);
  if (ids.length > 1) query = query.in("institute_id", ids);
  if (teamId) query = query.eq("team_id", teamId);
  if (activeOnly) query = query.eq("status", "Active");
  if (!activeOnly && !includeFormer) query = query.neq("status", "Former");
  const { data, error } = await query;
  if (error) {
    if (isMissingDemoTableError(error)) return [];
    throw error;
  }
  return (data || []).map(mapDemoInstituteMemberRow);
};

export const mergeDemoInstituteMembers = (rows = [], demoRows = []) => [...(rows || []), ...(demoRows || [])];
